import { z } from 'zod';

export const peselNumberSchema = z.string().nonempty();

export const isPeselNumberError = (peselNumber: string) =>
  !peselNumberSchema.safeParse(peselNumber).success;
